import React from "react";
import { Badge, Icon } from "@culturehq/components";

import { RecognitionTypeLargeImage } from "components/recognitions/RecognitionTypeImage";
import LazyEditorOutput from "components/editor/LazyEditorOutput";

import Recognizer from "./Recognizer";
import AutoRecognizer from "./AutoRecognizer";
import useValueClick from "./useValueClick";

const RecognizedValue = ({ value }) => {
  const onValueClick = useValueClick(value);

  return (
    <>
      <Badge primary onClick={onValueClick}>
        <Icon icon="diamond" />
        {value.name}
      </Badge>
      {" "}
    </>
  );
};

const RecognitionMiddle = ({ recognition }) => (
  <>
    <div className="recognitions__middle">
      {recognition.recognitionType && (
        <div className="recognitions__type">
          <RecognitionTypeLargeImage
            recognitionType={recognition.recognitionType}
          />
        </div>
      )}

      {recognition.creator && (
        <div className="recognitions__body">
          {recognition.recognitionType && (
            <h3>{recognition.recognitionType.name}</h3>
          )}
          <LazyEditorOutput output={recognition.body} />
          <p className="recognitions__recognition__values">
            {recognition.organizationValues.map(value => (
              <RecognizedValue key={value.id} value={value} />
            ))}
          </p>
        </div>
      )}
    </div>
    {
      recognition.creator
        ? <Recognizer user={recognition.creator} />
        : <AutoRecognizer />
    }
  </>
);

export default RecognitionMiddle;
